import { ErrorArrayProps } from "./interface"

export const errorPushFormat=({data,message,error,column,serial_no}:ErrorArrayProps)=>{
    return { id: data.product_id, message: message, error: error, column: column,serial_no:serial_no }
}